'use client';

import useEmblaCarousel from 'embla-carousel-react';
import { useTranslations } from 'next-intl';

import { useCallback } from 'react';

import { Button } from '@/app/_components/ui/button';
import { Icons } from '@/app/_components/ui/icons';
import { DetailedProject } from '@/domain/project/types';

import NewsCard from './news-card';

interface NewsProps {
  press: DetailedProject['press'];
}

const News = ({ press }: NewsProps) => {
  const t = useTranslations();
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'center',
    loop: true,
  });

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) {
      return;
    }

    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) {
      return;
    }

    emblaApi.scrollNext();
  }, [emblaApi]);

  if (press.length === 0) {
    return null;
  }

  return (
    <div
      className="flex scroll-mt-44 flex-col gap-8 md:scroll-mt-32 md:gap-12"
      id="news"
    >
      <h2 className="text-3xl font-bold">{t('pages.project.news.title')}</h2>

      <div className="relative w-full">
        <div className="absolute inset-y-0 left-0 z-10 flex w-12 items-center justify-start bg-gradient-to-r from-white">
          <Button
            onClick={onPrevButtonClick}
            variant="ghost"
            className="size-5 rounded-full p-0 text-primary hover:text-primary-100"
          >
            <Icons.SurroundedArrow className="size-5" />
          </Button>
        </div>

        <div className="p-0 xl:my-0">
          <div className="overflow-hidden px-8 lg:pl-0" ref={emblaRef}>
            <div className="flex touch-pan-y backface-hidden">
              {press.map((pressElement) => (
                <NewsCard
                  key={pressElement.title}
                  pressElement={pressElement}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="absolute inset-y-0 right-0 z-10 flex w-12 items-center justify-end bg-gradient-to-l from-white">
          <Button
            onClick={onNextButtonClick}
            variant="ghost"
            className="size-5 rounded-full p-0 text-primary hover:text-primary-100"
          >
            <Icons.SurroundedArrow className="size-5 rotate-180" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default News;
